import { createSelector } from 'reselect'

export default createSelector(
	[
		state => state.oeq.entityUID,
		state => state.oeq.timer.value,
	],
	(entityUID, timerValue) => ({
		entityUID,
		timerValue,
	})
)
